import "./ProfileComponent.scss";
import React, { useContext, useEffect, useState } from "react";
import TitleComponent from "../../shared/titleComponent/TitleComponent";
import { useNavigate } from "react-router-dom";
import { Button, Grid, MenuItem, Select, Tooltip } from "@mui/material";
import CustomModalComponent from "../../shared/customModalComponent/CustomModalComponent";
import Context from "../../context/Context";
import { BEURL } from "../../api/BaseUrl";
import apiEndpoints from "../../api/EndPoints";
import axios from "axios";
import LoginPromptComponent from "../../shared/loginPromptComponent/LoginPromptComponent";

// import { PDFDownloadLink } from "@react-pdf/renderer";
// import ProfileCertificate from "../../shared/eCertificate/ProfileCertificate";
import {
  capitalizeString,
  certificateLevels,
  getValueForScore,
  getScoreFromValue,
} from "../../shared/constants";
// import MapComponent from "../../shared/mapComponent/MapComponent";

import { MdOutlineEdit } from "react-icons/md";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import LinearProgress from "@mui/material/LinearProgress";
// import { quizToppers } from "../../utils/testToppers";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles({
  table: {
    minWidth: 650,
  },
  headerCell: {
    fontWeight: "bold",
    backgroundColor: "#000",
    fontFamily: "CaustenEB",
    fontSize: "1.25rem",
    color: "white",
    "@media only screen and (max-width: 900px)": {
      fontSize: "1rem",
    },
  },
  textCell: {
    fontFamily: "CaustenR",
    fontSize: "1rem",
    "@media only screen and (max-width: 900px)": {
      fontSize: "0.75rem",
    },
  },
  progressColorPrimary: {
    backgroundColor: "#0097D4",
    borderRadius: "5px",
    height: "10px",
  },
  progressBarColorPrimary: {
    backgroundColor: "#FDB913",
    height: "10px",
  },
});

const ProfileComponent = () => {
  const navigate = useNavigate();
  const {
    isLoggedIn,
    setHost,
    setLoadingDisplayFlag,
    setNotificationType,
    setNotificationMessage,
    setNotificationDisplayFlag,
  } = useContext(Context);
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [city, setCity] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [intro, setIntro] = useState("");
  const [userName, setUserName] = useState("");
  const [hostedcount, setHostedcount] = useState(0);
  const [wonCount, setWonCount] = useState(0);
  const [playedCount, setPlayedCount] = useState(0);
  const [pScore, setPScore] = useState(0);
  const [yetToQuiz, setYetToQuiz] = useState(0);
  const [pLevelKey, setPLevelKey] = useState(0);
  const [imageURL, setImageURL] = useState("");
  const [role, setRole] = useState("");
  const [openCancelConfirmationModal, setOpenCancelConfirmationModal] =
    useState(false);
  const [tableDataType, setTableDataType] = useState("INDIA");

  const setAlert = (type, message) => {
    setNotificationType(type);
    setNotificationMessage(message);
    setNotificationDisplayFlag(true);
  };

  const classes = useStyles();

  useEffect(() => {
    if (!isLoggedIn)
      // do not proceed if not logged in
      return;
    const url_profile = BEURL + apiEndpoints.getProfile;
    const url_stats = BEURL + apiEndpoints.getUserStats;
    setLoadingDisplayFlag(true);
    axios
      .get(url_profile)
      .then((res) => {
        if (!!!res.data["username"])
          // if social login users  haven't entered a username yet
          navigate("/editprofile");
        setFirstName(res.data["given_name"]);
        setLastName(res.data["family_name"]);
        setCity(res.data["locale"]);
        setPhoneNumber(res.data["phone_number"]);
        setIntro(res.data["profile"]);
        setUserName("@" + res.data["username"]);
        setImageURL(
          res.data["picture"] ||
            "https://qshala-quiz-profile-images.s3.ap-south-1.amazonaws.com/no-image.jpg"
        );
        axios
          .get(url_stats)
          .then((res) => {
            setHostedcount(res.data["quizzesHosted"]);
            setWonCount(res.data["quizzesWon"]);
            setPlayedCount(res.data["quizzesPlayed"]);
            setRole(res.data["role"]);
            setLoadingDisplayFlag(false);
          })
          .catch((err) => console.log(err));
      })
      .catch((err) => console.log(err));
  }, []);

  useEffect(() => {
    calculateScoreAndLevel(hostedcount, wonCount, playedCount);
  }, [hostedcount, wonCount, playedCount]);

  const handleCancelSubscription = () => {
    setOpenCancelConfirmationModal(false);
    setLoadingDisplayFlag(true);
    axios
      .get(BEURL + apiEndpoints.cancelSubscription)
      .then((res) => {
        setAlert("info", res.data);
      })
      .catch((err) => setAlert("error", err.response.data))
      .finally(() => setLoadingDisplayFlag(false));
  };

  const handleSelectDataChange = (event) => {
    setTableDataType(event.target.value);
  };

  const calculateScoreAndLevel = (hcount, wCount, pCount) => {
    // Make values 1 if 0
    hcount = hcount || 1;
    wCount = wCount || 1;
    pCount = pCount || 1;

    let totalCount = hcount + wCount + pCount
    // Convert points to a specific value in a range
    let profileScore = getScoreFromValue({ value: totalCount });

    let currentLevel = Math.floor(profileScore / 100); // Find quotient as value is between 100 and 1000
    setPLevelKey(currentLevel);
    setPScore(profileScore);
    // Actual quizzes for next level score
    setYetToQuiz(getValueForScore({ score: (currentLevel + 1) * 100 })-totalCount)
  };

  const allQuizImages = Object.values(certificateLevels).map((val, ind) => {
    return (
      <img
        key={val}
        style={{
          border: ind == pLevelKey - 1 ? "4px solid #FDB913" : "none",
        }}
        src={"/images/level_badges/" + val + ".png"}
        alt={val}
      />
    );
  });

  return (
    <>
      <div className="profile">
        {isLoggedIn ? (
          <>
            <TitleComponent
              title="My Profile"
              handleOnClick={() => navigate("/")}
              align="left"
              style={{ marginRight: "auto", marginLeft: "14%" }}
              isIcon={true}
              onIconClick={() => navigate("/editprofile")}
            />

            {/* Profile Level */}
            <div className="profile__quizProfileLevel">
              <div>
                <div className="profile__quizText">
                  You are {yetToQuiz} quizzes away from reaching the next level,{" "}
                  <span style={{ fontStyle: "italic", color: "#FFC72C" }}>
                    {certificateLevels[pLevelKey + 1]}
                  </span>
                </div>
                <div 
                  className="profile__quizText profile__quizLink" style={{fontFamily: "CaustenL"}}
                  onClick={() => {
                    setHost(true);
                    sessionStorage.setItem("isHost", true);
                    navigate("/quizselection");
                  }}
                >
                  Host, Play and Win more quizzes to acheive Higher Levels !
                </div>
              </div>
              <div className="profile__quizlevels">{allQuizImages}</div>
              <Box sx={{ width: "100%" }}>
                <LinearProgress
                  classes={{
                    colorPrimary: classes.progressColorPrimary,
                    barColorPrimary: classes.progressBarColorPrimary,
                  }}
                  variant="determinate"
                  value={(pLevelKey / 9) * 100}
                />
              </Box>
            </div>

            {/* Profile Stats */}
            <div className="profile__quizstats">
              <Grid
                container
                rowSpacing={1}
                columnSpacing={{ xs: 1, sm: 2, md: 10, lg: 30 }}
              >
                <Grid item xs={12} md={6}>
                  <div className="profile__quizstats__item">
                    <p>Number of quizzes played</p>
                    <p>{playedCount}</p>
                  </div>
                </Grid>
                <Grid item xs={12} md={6}>
                  <div className="profile__quizstats__item">
                    <p>Number of quizzes hosted</p>
                    <p>{hostedcount}</p>
                  </div>
                </Grid>
                <Grid item xs={12} md={6}>
                  <div className="profile__quizstats__item">
                    <p>Number of quizzes won</p>
                    <p>{wonCount}</p>
                  </div>
                </Grid>
                <Grid item xs={12} md={6}>
                  <div className="profile__quizstats__item">
                    <p>Overall points</p>
                    <p>{pScore}/1000</p>
                  </div>
                </Grid>
                {/* <Grid item xs={12} md={6}>
                  <div className="profile__quizstats__item">
                    <Tooltip
                      title="Download your profile certificate!"
                      placement="bottom"
                      arrow
                    >
                      <p className="pdf_downlaod_link">
                        <PDFDownloadLink
                          document={
                            <ProfileCertificate
                              name={capitalizeString(
                                sessionStorage.getItem("name")
                              )}
                              score={pScore}
                              level={certificateLevels[pLevelKey]}
                            />
                          }
                          fileName="profile_certificate.pdf"
                        >
                          {({ blob, url, loading, error }) =>
                            loading ? "Loading..." : "Certificate"
                          }
                        </PDFDownloadLink>
                      </p>
                    </Tooltip>
                  </div>
                </Grid> */}
              </Grid>
            </div>

            {/* Profile Info */}
            <div className="profile__userinfo">
              <div className="profile__userinfo__left">
                <div className="profile__userinfo__circularimage">
                  <img src={imageURL} alt="" />
                </div>
              </div>
              <div className="profile__userinfo__right">
                <p>
                  {firstName} {lastName}
                </p>
                <div className="profile__userinfo__right__4x4">
                  <Grid
                    container
                    alignItems="center"
                    justifyItems="center"
                    rowSpacing={{ xs: 1, sm: 1, md: 2 }}
                    columnSpacing={{ xs: 1, sm: 2, md: 10 }}
                  >
                    <Grid item xs={12} md={12}>
                      <div className="profile__userinfo__right__4x4__items">
                        <img src="/images/profile_assets/ic_profile.svg" />{" "}
                        {userName}
                      </div>
                    </Grid>
                    {phoneNumber && (
                      <Grid item xs={12} md={12}>
                        <div className="profile__userinfo__right__4x4__items">
                          <img src="/images/profile_assets/ic_mobile.svg" />{" "}
                          {phoneNumber}
                        </div>
                      </Grid>
                    )}
                    <Grid item xs={12} md={12}>
                      <div className="profile__userinfo__right__4x4__items">
                        <img src="/images/profile_assets/ic_map.svg" /> {city}
                      </div>
                    </Grid>
                    <Grid item xs={12} md={12} 
                      sx={{ 
                        display: "flex", 
                        alignItems: {
                          xs: "start",
                          sm: "center"
                        }, 
                        gap: "1rem",
                        flexDirection: {
                          xs: 'column',
                          sm: 'row'
                        },
                        }}>
                        <div 
                          className="profile__icon"
                          onClick={() => navigate("/editprofile")}
                        >
                          <MdOutlineEdit size={20} />
                          <p>Edit Profile</p>
                        </div>
                        {role === "Premium" && (
                          <div className="profile__userinfo__right__4x4__items">
                            <button
                              onClick={() => setOpenCancelConfirmationModal(true)}
                              style={{cursor: 'pointer'}}
                            >
                              Cancel Subscription
                            </button>
                          </div>
                        )}
                    </Grid>
                  </Grid>
                </div>
                <div className="profile__userinfo__right__badge">
                  <div className="profile__userinfo__right__badge__title">
                    Badges
                  </div>
                  <div className="profile__userinfo__right__badge__text">
                    <img
                      src={
                        "/images/level_badges/" +
                        certificateLevels[pLevelKey] +
                        ".png"
                      }
                      alt={certificateLevels[pLevelKey]}
                    />
                    <div>
                      You are {yetToQuiz} quizzes away from reaching the next level,{" "}
                      <span style={{ fontStyle: "italic", color: "#FFC72C" }}>
                        {certificateLevels[pLevelKey + 1]}
                      </span>
                      . Host, Play and Win more quizzes to acheive Higher Levels!
                    </div>
                    <button
                      className="profile__quizLinkButton"
                      style={{
                        marginTop: "1rem"
                      }}
                      onClick={() => {
                        setHost(true);
                        sessionStorage.setItem("isHost", true);
                        navigate("/quizselection");
                      }}
                    >
                      Play More!
                    </button>
                  </div>
                </div>
              </div>
            </div>
            
            
            
            {/* Quiz Toppers Block */}
            {/* <div
              style={{
                paddingBottom: "min(5%, 3rem)",
                borderBottom: "2px solid lightgray",
                margin: "min(5%, 3rem)",
                marginTop: 0,
              }}
            >
              <div
                className="profile__quizText"
                style={{ textAlign: "left", marginBottom: "min(3%, 2rem)" }}
              >
                Quiz Toppers
              </div>
              <p className="profile__quizText" style={{fontFamily: "CaustenL", marginBottom: "1rem"}}>
                You are ranked <em style={{color: "#FFC72C"}}>476</em> in your state and <em style={{color: "#FFC72C"}}>5729</em> in
                India.
              </p>
              <div className="profile__quizSelect">
                <p>Select State</p>
                <Select
                  value={tableDataType}
                  onChange={handleSelectDataChange}
                  label="Select State"
                  sx={{
                    width: "20rem",
                    height: "2rem",
                    fontFamily: "CaustenR",
                    color: "#FFF",
                    backgroundColor: "#000",
                    "& .MuiOutlinedInput-notchedOutline": {
                      borderColor: "#000",
                    },
                    "&:hover .MuiOutlinedInput-notchedOutline": {
                      borderColor: "#000",
                    },
                    "& .Mui-focused": {
                      borderColor: "#000",
                    },
                    "& .MuiSvgIcon-root": {
                      color: "#FFF",
                    },
                  }}
                  MenuProps={{
                    PaperProps: {
                      sx: {
                        bgcolor: "#007FB3",
                        color: "#FFF",
                        "& .MuiMenuItem-root": {
                          padding: 2,
                          fontFamily: "CaustenR",
                        },
                      },
                    },
                  }}
                >
                  <MenuItem value="INDIA">
                    <em>India - All States</em>
                  </MenuItem>
                  <MenuItem value={"UP"}>Uttar Pradesh</MenuItem>
                  <MenuItem value={"MH"}>Maharastra</MenuItem>
                  <MenuItem value={"WB"}>West Bengal</MenuItem>
                </Select>
              </div>
              <TableContainer component={Paper}>
                <Table
                  className={classes.table}
                  sx={{ minWidth: 650 }}
                  aria-label="simple table"
                >
                  <TableHead>
                    <TableRow>
                      <TableCell className={classes.headerCell}>Rank</TableCell>
                      <TableCell className={classes.headerCell} align="right">
                        Name
                      </TableCell>
                      <TableCell className={classes.headerCell} align="right">
                        Score
                      </TableCell>
                      <TableCell className={classes.headerCell} align="right">
                        State
                      </TableCell>
                      <TableCell className={classes.headerCell} align="right">
                        District
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {quizToppers[tableDataType].map((row, index) => (
                      <TableRow
                        key={row.rank}
                        sx={{
                          ".MuiTableCell-root, .material-icons-outlined": {
                            backgroundColor: index % 2 ? "#F3F7EE" : "#FFFFFF",
                          },
                          "&:last-child td, &:last-child th": { border: 0 },
                          "&:hover .MuiTableCell-root, &:hover .material-icons-outlined":
                            {
                              fontWeight: 900,
                              backgroundColor: "#F2BC44",
                            },
                        }}
                      >
                        <TableCell
                          className={classes.textCell}
                          component="th"
                          scope="row"
                        >
                          {row.rank}
                        </TableCell>
                        <TableCell className={classes.textCell} align="right">
                          {row.name}
                        </TableCell>
                        <TableCell className={classes.textCell} align="right">
                          {row.score}
                        </TableCell>
                        <TableCell className={classes.textCell} align="right">
                          {row.state}
                        </TableCell>
                        <TableCell className={classes.textCell} align="right">
                          {row.district}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </div> */}
            {/* Statewise Map Block */}
            {/* <div style={{ margin: "min(5%, 3rem)", marginTop: 0 }}>
              <div
                className="profile__quizText"
                style={{ textAlign: "left", marginLeft: "min(5%, 3rem)" }}
              >
                Statewise Quiz Points
              </div>
              <MapComponent />
            </div> */}
          </> 
        ) : ( //else if not logged in prompt to login
          <LoginPromptComponent
            open={!isLoggedIn}
            handleClose={() => navigate("/")}
          />
        )}
      </div>
      <CustomModalComponent
        open={openCancelConfirmationModal}
        handleClose={() => setOpenCancelConfirmationModal(false)}
      >
        <div className="selectMultiplayer__modal">
          <h2 style={{ textAlign: "center" }}>
            Are you sure you want to cancel your QShala Premium Subscription?
          </h2>
          <div className="profile__cancelModal">
            <Button
              variant="contained"
              style={{ backgroundColor: "#30b2e7" }}
              className="selectMultiplayer__modalButton"
              onClick={handleCancelSubscription}
            >
              Yes
            </Button>
            <Button
              variant="contained"
              style={{ backgroundColor: "#30b2e7" }}
              className="selectMultiplayer__modalButton"
              onClick={() => setOpenCancelConfirmationModal(false)}
            >
              No
            </Button>
          </div>
        </div>
      </CustomModalComponent>
    </>
  );
};
export default ProfileComponent;